<template>
  <div>
    <!--顶部工具条-->
    <el-col :span="24">
      <el-form :inline="true">
        <el-form-item label="">
          <el-input
            style="width: 170px"
            v-model="filters.phoneNumber"
            placeholder="请输入号码"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select
            style="width: 170px"
            v-model="filters.isEnable"
            placeholder="请选择号码状态"
            clearable
          >
            <el-option
              v-for="item in isEnableOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="省份:">
          <el-select
            style="width: 100px"
            clearable
            v-model="filters.provinceId"
            placeholder="请选择"
            @change="handleProvinceChange"
          >
            <el-option
              v-for="item in provinceOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市:">
          <el-select
            style="width: 100px"
            v-model="filters.cityId"
            placeholder="请选择"
            clearable
          >
            <el-option
              v-for="item in cityOptions"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="导入日期:">
          <el-date-picker
            v-model="serachTimer"
            :unlink-panels="true"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="handleSearch">查询</el-button>
        </el-form-item>
        <el-form-item style="margin-left: 20px">
          <el-button type="primary" @click="importPhoneFun">导入号码</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <!--列表-->
    <el-table
      :data="tableData"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%"
      border
      class="custom-padding-table"
    >
      <el-table-column
        prop="numberName"
        label="姓名"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="phoneNumber"
        label="手机号"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="batch"
        label="批次"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="source"
        label="来源"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="success" v-if="scope.row.source == 1">第三方</el-tag>
          <el-tag v-if="scope.row.source == 2">本公司</el-tag>
        </template></el-table-column
      >
      <el-table-column
        prop="provinceName"
        label="省份"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="cityName"
        label="城市"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="industry"
        label="行业"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="gender"
        label="性别"
        align="center"
        show-overflow-tooltip
      >
        <template #default="scope">
          <el-tag type="info" v-if="scope.row.gender == 0">未知</el-tag>
          <el-tag  v-if="scope.row.gender == 1">男</el-tag>
          <el-tag type="success" v-if="scope.row.gender == 2">女</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="ageBracket"
        label="年龄段"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="occupation"
        label="职业身份"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        prop="createTime"
        label="导入日期"
        align="center"
        show-overflow-tooltip
        width="300"
      ></el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col :span="24" class="pageBar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>

    <!--导入号码库弹窗-->
    <el-dialog
      title="导入号码"
      :visible.sync="importPhoneVisible"
      v-model="importPhoneVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="importPhoneForm"
        label-width="100px"
        ref="addForm"
        style="max-width: 700px"
        :rules="importPhoneFormRules"
      >
        <el-form-item label="号码库名称：">
          <el-input
            v-model="numberName"
            auto-complete="off"
            placeholder=""
            disabled
          ></el-input>
        </el-form-item>
        <!-- 上传区域 -->
        <el-form-item label="号码库状态: ">
          <el-upload
            ref="upload"
            action=""
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :auto-upload="false"
            :show-file-list="true"
            accept=".xls,.xlsx"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择导入文件(Excel)</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="importPhoneVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="importPhoneSubmit"
          :loading="listLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import util from "../../../../util/date";
import {
  getAreaDictionaryList,
  getPhoneNumberDetailListApi,
  addNumberLibraryDetailApi,
} from "../../../api/api";
// 修改点：引入 axios 用于发送文件上传请求
import axios from "axios";

export default {
  components: {},
  data() {
    return {
      util: "",
      tableData: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        phoneNumber: "",
        isEnable: "",
        provinceId: "",
        cityId: "",
        numberLibraryId: "",
      },
      serachTimer: "",
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      provinceOptions: [],
      cityOptions: [],
      // 用户来源
      isEnableOptions: [
        {
          value: true,
          label: "启用",
        },
        {
          value: false,
          label: "禁用",
        },
      ],
      pid: 0,
      importPhoneVisible: false,
      importPhoneForm: {
        numberLibraryId: "",
        file: "",
      },
      numberName: "",
      importPhoneFormRules: {
        numberName: [{ required: true, message: "请输入", trigger: "blur" }],
      },
      selectedFile: null,
      fileList: [],
    };
  },
  methods: {
    importPhoneSubmit() {
      // 校验是否选择了文件
      if (!this.selectedFile) {
        this.$message.warning("请先选择要导入的 Excel 文件");
        return;
      }
      // 校验 ID
      if (!this.importPhoneForm.numberLibraryId) {
        this.$message.error("未获取到号码库 ID");
        return;
      }

      this.$confirm("确认提交导入吗？", "提示", {}).then(() => {
        this.listLoading = true;
        // 构造 FormData
        const formData = new FormData();
        formData.append("file", this.selectedFile);
        formData.append(
          "numberLibraryId",
          this.importPhoneForm.numberLibraryId
        );
        // 发送请求 (使用 axios 直接发送 formData)
        axios
          .post(addNumberLibraryDetailApi, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: "Bearer " + this.getToken(),
            },
          })
          .then((res) => {
            this.listLoading = false;
            // 根据你的后端返回结构调整判断条件
            if (res.data.success || res.code === 200) {
              this.$message({
                message: res.data.message || "导入成功",
                type: "success",
              });
              this.importPhoneVisible = false;

              // 重置状态 (修改点：统一使用 selectedFile)
              this.selectedFile = null;
              this.fileList = [];
              if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
              }

              this.getList(); // 刷新列表
            } else {
              this.$message({
                message: res.data.message || "导入失败",
                type: "error",
              });
            }
          })
          .catch((err) => {
            this.listLoading = false;
            console.error(err);
            this.$message.error(
              "网络请求失败：" + (err.response?.data?.message || err.message)
            );
          });
      });
    },
    // 2. 【新增】文件改变事件：读取二进制文件
    handleFileChange(file) {
      this.selectedFile = file.raw;
      this.fileList = [file]; // 更新文件列表显示
      console.log("文件已选中:", this.selectedFile);
      this.$message.info("文件已就绪，请点击提交");
    },
    // 上传前校验
    beforeUpload(file) {
      const validType = [
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ];
      const isValidType = validType.includes(file.type);
      const isLt10M = file.size / 1024 / 1024 < 10;

      if (!isValidType) {
        this.$message.error("只能上传 Excel 文件 (.xls 或 .xlsx)！");
      }
      if (!isLt10M) {
        this.$message.error("文件大小不能超过 10MB！");
      }

      return isValidType && isLt10M;
    },
    // 获取token
    getToken() {
      return localStorage.getItem("Token");
    },
    // 【新增】查询按钮调用的方法
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },

    importPhoneFun() {
      this.importPhoneVisible = true;
    },
    getList() {
      var params = {
        ...this.filters,
        startTime: this.serachTimer
          ? this.formatCreateTime(this.serachTimer[0])
          : "",
        endTime: this.serachTimer
          ? this.formatCreateTime(this.serachTimer[1])
          : "",
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
      };

      getPhoneNumberDetailListApi(params).then((res) => {
        this.tableData = res.data.response.data;
        this.pages.dataCount = res.data.response.dataCount;
      });
    },

    // 当省份改变时重新获取城市
    handleProvinceChange(val) {
      this.filters.cityId = "";
      this.pid = val;
      this.getProvinceCityInfo(1);
    },
    // 获取省市接口
    getProvinceCityInfo(type) {
      var params = {
        pid: this.pid,
      };
      getAreaDictionaryList(params).then((res) => {
        if (type == 0) {
          this.provinceOptions = res.data.response;
        }
        if (type == 1) {
          this.cityOptions = res.data.response;
        }
      });
    },
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },

    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
  },
  mounted() {
    let numberLibraryId = this.$route.query.id;
    let numberName = this.$route.query.numberName;
    this.filters.numberLibraryId = numberLibraryId;
    this.importPhoneForm.numberLibraryId = numberLibraryId;
    this.numberName = numberName;
    this.getList();
    this.getProvinceCityInfo(0);
    this.util = util;
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
